import React, { useEffect, useState } from 'react';
import { Modal, Button, Typography, Tag, Space } from 'antd';
import {
  EnvironmentOutlined, TeamOutlined, ThunderboltOutlined,
  SendOutlined, InboxOutlined, MessageOutlined,
} from '@ant-design/icons';

const { Title, Text, Paragraph } = Typography;

const BRAND = '#25D366';
const BRAND_DARK = '#128C7E';
const LS_KEY = 'community_welcome_seen_v1';

const AVAILABLE = [
  { icon: <EnvironmentOutlined />, title: 'Mapa da região', desc: 'Descubra times e boleiros perto de você.' },
  { icon: <TeamOutlined />, title: 'Filtros por posição e nível', desc: 'Precisa de goleiro? Zagueiro? Meia? Filtre por posição e skill.' },
  { icon: <ThunderboltOutlined />, title: 'Perfis dos jogadores', desc: 'Veja reputação, avaliações e frequência.' },
  { icon: <SendOutlined />, title: 'Convidar pra jogar', desc: 'Time com vaga? Chama um boleiro da região direto pelo Futezap.' },
  { icon: <InboxOutlined />, title: 'Receber convites de outros times', desc: 'Fica visível na comunidade e recebe chamados quando faltar jogador.' },
  { icon: <MessageOutlined />, title: 'Bate-papo com organizadores', desc: 'Sem precisar sair pro WhatsApp — combina tudo aqui.' },
];

const FeatureItem = ({ item, comingSoon }) => (
  <div style={{
    display: 'flex', gap: 12, padding: 14, borderRadius: 12,
    background: comingSoon ? '#fafafa' : '#f6ffed',
    border: `1px solid ${comingSoon ? '#f0f0f0' : '#b7eb8f'}`,
  }}>
    <div style={{
      width: 40, height: 40, borderRadius: 10, flexShrink: 0,
      display: 'grid', placeItems: 'center', fontSize: 18,
      background: comingSoon ? '#fff' : `linear-gradient(135deg, ${BRAND} 0%, ${BRAND_DARK} 100%)`,
      color: comingSoon ? '#8c8c8c' : '#fff',
      border: comingSoon ? '1px solid #e8e8e8' : 'none',
    }}>{item.icon}</div>
    <div style={{ flex: 1 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 2 }}>
        <Text strong style={{ fontSize: 14 }}>{item.title}</Text>
        {comingSoon && <Tag color="gold" style={{ margin: 0, fontSize: 10, fontWeight: 600 }}>EM BREVE</Tag>}
      </div>
      <Text type="secondary" style={{ fontSize: 12, lineHeight: 1.4 }}>{item.desc}</Text>
    </div>
  </div>
);

const CommunityWelcomeModal = ({ forceOpen = false, onClose }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (forceOpen) { setOpen(true); return; }
    const seen = localStorage.getItem(LS_KEY);
    if (!seen) setOpen(true);
  }, [forceOpen]);

  const close = () => {
    localStorage.setItem(LS_KEY, '1');
    setOpen(false);
    onClose && onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={close}
      footer={null}
      maskClosable={false}
      width={560}
      styles={{ body: { padding: 0 } }}
    >
      {/* Header colorido */}
      <div style={{
        background: `linear-gradient(135deg, ${BRAND} 0%, ${BRAND_DARK} 100%)`,
        color: '#fff', padding: '32px 32px 40px 32px',
        borderRadius: '8px 8px 0 0',
        position: 'relative', overflow: 'hidden',
      }}>
        <div style={{
          position: 'absolute', inset: 0, opacity: 0.5,
          backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='60' height='60' viewBox='0 0 60 60'><path d='M60 0H0v60' fill='none' stroke='rgba(255,255,255,0.08)' stroke-width='1'/></svg>\")"
        }} />
        <div style={{ position: 'relative' }}>
          <div style={{
            width: 60, height: 60, borderRadius: 18,
            background: 'linear-gradient(135deg, #fff 0%, rgba(255,255,255,0.9) 100%)',
            display: 'grid', placeItems: 'center', fontSize: 32,
            boxShadow: '0 10px 24px rgba(0,0,0,0.2)', marginBottom: 16,
          }}>🌎</div>
          <Title level={3} style={{ color: '#fff', margin: 0, fontWeight: 800 }}>
            Bem-vindo à Comunidade
          </Title>
          <Text style={{ color: 'rgba(255,255,255,0.9)', fontSize: 15 }}>
            O lugar onde você acha times, boleiros e joga em qualquer lugar.
          </Text>
        </div>
      </div>

      <div style={{ padding: 24 }}>
        <Paragraph style={{ marginBottom: 20 }}>
          <Text>
            A comunidade Futezap conecta você a outros times e jogadores da sua região.
          </Text>
        </Paragraph>

        <div style={{ marginBottom: 22 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
            <Tag color="green" style={{ margin: 0, fontWeight: 700 }}>DISPONÍVEL</Tag>
            <Text strong>O que você já pode fazer</Text>
          </div>
          <Space direction="vertical" style={{ width: '100%' }} size={10}>
            {AVAILABLE.map((i, idx) => <FeatureItem key={idx} item={i} />)}
          </Space>
        </div>

        <Button
          type="primary" block size="large"
          onClick={close}
          style={{
            height: 48, borderRadius: 12, background: BRAND, borderColor: BRAND,
            fontWeight: 700, fontSize: 15,
            boxShadow: `0 8px 20px rgba(37, 211, 102, 0.35)`,
          }}
        >
          Explorar a comunidade
        </Button>
        <div style={{ textAlign: 'center', marginTop: 10, fontSize: 12, color: '#999' }}>
          Você pode reabrir isso a qualquer momento no ícone <b>Ajuda</b>.
        </div>
      </div>
    </Modal>
  );
};

export default CommunityWelcomeModal;
